import { useEffect } from "react";
import { useAppDispatch } from "../../hooks/store-hooks";
import EventPage from "../../components/events";
import { useLazyGetHomeDataQuery } from "../../store/api/homeApi";
import { addPostData } from "../../store/slices/homeSlice";

const Events = () => {
  let isFetched = false;
  const dispatch = useAppDispatch();

  const [trigger] = useLazyGetHomeDataQuery();
  useEffect(() => {
    if (!isFetched) {
      getHomeData();
      isFetched = true;
    }
  }, []);

  const getHomeData = async () => {
    try {
      const res = await trigger()?.unwrap();
      if (res?.success) {
        dispatch(addPostData(res.data));
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div className="min-h-screen w-full bg-white">
      <EventPage />
    </div>
  );
};

export default Events;
